import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { Logo } from '../components/ds';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const clerkAppearance = {
  variables: {
    colorPrimary: '#1E4FBE',
    fontFamily: FONT,
    borderRadius: '8px',
  },
  elements: {
    card: {
      boxShadow: '0 1px 3px rgba(16,22,35,0.06), 0 1px 2px rgba(16,22,35,0.04)',
      border: '1px solid #D7DCE4',
      borderRadius: '16px',
      padding: '32px 28px',
    },
    headerTitle: { fontSize: '20px', fontWeight: 700, letterSpacing: '-0.011em', color: '#101623' },
    headerSubtitle: { fontSize: '13px', color: '#667085' },
    formButtonPrimary: {
      fontSize: '13.5px',
      textTransform: 'none',
    },
    footerActionLink: { color: '#1E4FBE' },
    rootBox: { width: '100%' },
  },
};

const SignUpPage = () => {
  return (
    <div style={{
      display: 'flex', minHeight: '100vh', fontFamily: FONT,
      background: '#F5F7FA', alignItems: 'center', justifyContent: 'center',
      padding: '40px 24px',
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
          <Logo variant="lockup" height={34} />
        </div>
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/login"
          forceRedirectUrl="/dashboard"
          appearance={clerkAppearance}
        />
      </div>
    </div>
  );
};

export default SignUpPage;
